import { paramCase, capitalCase } from 'change-case';
import { useParams, useLocation } from 'react-router-dom';
// @mui
import { Container } from '@mui/material';
// routes

// sections

import HeaderBreadcrumbs from 'src/components/HeaderBreadcrumbs';
import useLocales from 'src/hooks/useLocales';
import useSettings from 'src/hooks/useSettings';
import { PATH_DASHBOARD } from 'src/routes/paths';
import Page from 'src/components/Page';
import StatusNewEditForm from './StatusNewEditForm';
// ----------------------------------------------------------------------

export default function StatusCreate() {
  const { themeStretch } = useSettings();

  const { pathname } = useLocation();
  const { translate } = useLocales();
  const { name = '' } = useParams();

  const isEdit = pathname.includes('edit');

  return (
    <Page
      title={
        !isEdit ? `${translate('Status.AddTitle')}` : `${translate('Status.UpdateTitle')}`
      }
    >
      <Container maxWidth={themeStretch ? false : 'lg'}>
        <HeaderBreadcrumbs
          heading={
            !isEdit
              ? `${translate('Status.CreateStatus')}`
              : `${translate('Status.EditStatus')}`
          }
          links={[
            { name: `${translate('Department.Dashboard')}`, href: PATH_DASHBOARD.root },
            {
              name: `${translate('Status.StatusList')}`,
              href: PATH_DASHBOARD.Status.list,
            },
            {
              name: !isEdit
                ? `${translate('Status.New')}`
                : `${translate('Status.Update')}`,
            },
          ]}
        />
        <StatusNewEditForm />
      </Container>
    </Page>
  );
}
